import * as React from 'react';

interface IProps {
	Id: number,
	Title: string,
	isExpanded: boolean,
	children?: React.ReactNode;
}

interface IState {
	isExpanded: boolean;
}

// Affiche un controle permettant de lancer la lecture d'un son
export class KPanel extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			isExpanded: this.props.isExpanded,	
		};
	}

	onClick = () => {
		this.setState({ isExpanded: !this.state.isExpanded })
		this.forceUpdate();
	}

	renderTitleBar = () => {
		if (!this.props.Title) return "";

		//⬇ 🠻 🡇 🡅 ⯯ ⏫ ⏬

		return (<div className="Header">
			<div className="HeaderTitle"> {this.props.Title}</div>
			<div className="Expandable" onClick={this.onClick} >{this.state.isExpanded ? "⯭" : "⯯"}</div>
		</div>)
	}

	render() {
		let classBorder = this.props.Title ? " PanelBorder " : "";
		let header = this.renderTitleBar();
		
		let collapsed = !this.state.isExpanded ? " collapsed " : " expanded "
		if (!header) collapsed = " expanded " ;

		return (
			<div key={this.props.Id} className="KPanel">
				{header}
				<div className={"KPanelContent " + classBorder + collapsed } >
					{this.props.children}				
				</div>
			</div >
		)
	}
}